import React, { useRef } from 'react';
import { Body, Container, Heading } from '../../atoms';
import { SimpleDatalist } from '../../molecules';
export default function SimpleDatalistSection(param) {
    var title = param.title, description = param.description, entries = param.entries, className = param.className;
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: SimpleDatalistSection.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-6 sm:gap-8"
    }, /*#__PURE__*/ React.createElement("div", null, !!title && /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h2"
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "prose prose-neutral"
    }, description)), /*#__PURE__*/ React.createElement(SimpleDatalist, {
        entries: entries
    })));
}

//# sourceMappingURL=SimpleDatalistSection.js.map